import { render, staticRenderFns } from "./MultiUploaderOld.vue?vue&type=template&id=b17ff7b6&"
import script from "./MultiUploaderOld.vue?vue&type=script&lang=js&"
export * from "./MultiUploaderOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports